import { NavigationTopComponent } from './navigation-top/navigation-top.component';
import { AuthService } from './services/auth.service';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from './services/message.service';
import {ShipReportService} from './services/ship-report.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []
})
export class AppComponent implements OnInit {
  title = 'shore-portal';
  loggedIn = false;
  activeRoute = '';
  isAuthenticated = false;
  expandSideBar = false;
  accessToken = '';
  accessTokenExpires = '';
  accessTokenExpiresDate = 0;
  idTokenExpires = '';
  idTokenExpiresDate = 0;
  registration = '';
  queryParam = '';
  showModal = false;
  @ViewChild('navTop') navTop: NavigationTopComponent;

  @HostListener('click', ['$event'])
  onClick() {
    this.authService.resetActivityTimeouts();
  }

  @HostListener('keypress', ['$event'])
  onKeypress() {
    this.authService.resetActivityTimeouts();
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService,
    private reportService: ShipReportService
  ) {}

  ngOnInit() {
    this.authService.sessionExpiredEvent.subscribe((expiredEvent) => {
      if (expiredEvent.expired && this.authService.isLoggedIn()) {
        this.showModal = true;
        this.logout();
      }
    });
    const url = new URL(window.location.href);
    if (!this.loggedIn) {
      this.accessTokenExpires = url.searchParams.get('accessTokenExpires');
      this.idTokenExpires = url.searchParams.get('idTokenExpires');
      this.registration = url.searchParams.get('registration');
      //checking for deep linking
      this.queryParam = url.searchParams.get('fileNameB');

      if (typeof this.registration !== 'undefined' && this.registration) {
        this.authService.loggedIn = true;
        this.authService.preAuthenticate().subscribe(
          (accessToken) => {
            this.accessToken = accessToken['accessToken'];
            this.saveToken();
            this.authenticate();
            this.checkForDeepLink();
          },
          (error) => {
            this.messageService.error(error.error);

            this.logout();
          }
        );
      }
    }

    this.authService.resetLoggedInUserFromSession();
    this.loggedIn = this.authService.isLoggedIn();
    this.authService.loginStatusChanged.subscribe((loggedIn) => {
      this.loggedIn = loggedIn;
    });

    this.authService.authenticated.subscribe((show) => {
      this.isAuthenticated = show;
    });
  }

  authenticate() {
    // Attempting login so clear session variables
    this.authService.clearSessionVariables();

    this.authService.authenticate().subscribe((result: any) => {
      const redirectTo = localStorage.getItem('redirectUrl');
      if (redirectTo !== null) {
        this.router.navigate([redirectTo.substring(1)]);
        localStorage.removeItem('redirectUrl');
      } else {
        this.router.navigate(['users/messages']);
      }
    });
  }

  translateExtension(fileName: string) {
    var extension = fileName.split('.').pop();
		if ("pdf" == extension) {
			return 'application/pdf';
		} else if ("txt" == extension) {
			return 'text/plain';
		} else if ("dat" == extension) {
			return 'text/plain';
		} else if ("csv" == extension) {
			return 'text/csv';
		} else if ("xlsx" == extension) {
			return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
		} else {
			return 'text/plain';
    }
	}

  checkForDeepLink() {
    if (this.queryParam && this.queryParam.length != 0) {
      this.reportService.downloadReportByName(this.queryParam).subscribe(
        (response) => {
          var fileName = this.queryParam
          var file = new Blob([response], {type: this.translateExtension(fileName)});
          var newWindowLink = document.createElement('a');
          document.body.appendChild(newWindowLink);
          newWindowLink.style.display = 'none';
          newWindowLink.href = URL.createObjectURL(file);
          newWindowLink.download = fileName;
          newWindowLink.click()

          URL.revokeObjectURL(newWindowLink.href);
          newWindowLink.remove();
        },
        (error) => this.messageService.error(error.message)
      );
    }
  }

  saveToken() {
    sessionStorage.setItem('accessToken', this.accessToken);
    sessionStorage.setItem('registration', this.registration);
    sessionStorage.accessTokenExpiresDate = this.accessTokenExpiresDate;
    sessionStorage.idTokenExpiresDate = this.idTokenExpiresDate;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['login']);
  }

  hideNavBar() {
    this.navTop.hideNavBar();
    this.expandSideBar = false;
  }

  toggleSidebar(shouldExpandSideBar: boolean) {
    this.expandSideBar = shouldExpandSideBar;
  }
}
